/**
 * WOM Configuration — KICKR 360 (single product)
 * API: https://api.thewordofmouth.in/api/reviews/300/kickr_360_trainer_annual_training_program1
 */

var KICKR_PRODUCT_SLUG = 'kickr_360_trainer_annual_training_program1';
var KICKR_COMPANY_ID = '300';

function getProductTitle() {
  if (
    typeof window.ShopifyAnalytics !== 'undefined' &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.title
  ) {
    return window.ShopifyAnalytics.meta.product.title.trim();
  }

  var selectors = ['h2', 'h1[itemprop="name"]', '.product-details h1', '.product-details h2', 'h1'];
  var i;
  for (i = 0; i < selectors.length; i++) {
    var el = document.querySelector(selectors[i]);
    if (el && el.textContent) {
      return el.textContent.trim().replace(/\s+/g, ' ');
    }
  }

  var ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle && ogTitle.content) {
    return ogTitle.content.trim();
  }

  return 'KICKR 360 Trainer';
}

function getProductHandle() {
  return KICKR_PRODUCT_SLUG;
}

const vesselsWOMConfig = {
  name: 'KICKR 360',

  apiBaseUrl: 'https://api.thewordofmouth.in',
  companyId: KICKR_COMPANY_ID,

  getProductTitle: getProductTitle,
  getProductHandle: getProductHandle,
  defaultProductSlug: KICKR_PRODUCT_SLUG,
  fixedProductSlug: KICKR_PRODUCT_SLUG,

  reviewsApiUrl:
    'https://api.thewordofmouth.in/api/reviews/300/kickr_360_trainer_annual_training_program1?offset=0&limit=100',

  collectionApiUrl: 'https://api.thewordofmouth.in/api/300/',
  overallCompanyApiUrl: 'https://api.thewordofmouth.in/api/overall_company/300',
  brandReviewsApiUrl: 'https://api.thewordofmouth.in/api/brand-reviews/300',

  useLocalData: false,
  localDataUrl: '/assets/wom-product-data.json',

  debug: false,

  colors: {
    primary: '#000000',
    accent: '#000000',
    background: '#ffffff',
    text: '#111111',
    textLight: '#666666',
    border: '#e5e7eb',
    success: '#10b981',
    starColor: '#000000'
  },

  fontFamily: 'inherit',

  spacing: {
    cardRadius: '12px',
    cardPadding: '20px',
    gap: '16px'
  },

  components: {
    socialProof: false,
    liveUsers: false,
    ratingBreakdown: true,
    reviews: true
  },

  useCompanyWideData: false,

  settings: {
    liveUpdates: false,
    showVerifiedBadge: true,
    reviewsPerPage: 4
  },

  onWriteReview: function () {},
  onLoadMore: function () {}
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  window.vesselsWOMConfig = vesselsWOMConfig;
  window.clientWOMConfig = vesselsWOMConfig;
}
